import React, { useState, useRef, useEffect } from 'react';

import { Link } from "react-router-dom";


const Main: React.FC = () => {
  // useEffect para permitir scroll nesta página
  useEffect(() => {
    // Adicionar classe para permitir scroll no html e body
    document.documentElement.classList.add('allow-scroll');
    document.body.classList.add('allow-scroll');

    return () => {
      // Remover classe ao sair da página
      document.documentElement.classList.remove('allow-scroll');
      document.body.classList.remove('allow-scroll');


    };
  }, []);


  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#cd0c62",
        margin: 0,
        padding: "2rem 1rem",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "'Poppins', sans-serif"
      }}
    >
      <img
        src="images/logo.png"
        alt="Medtronic Logo"
        style={{
          maxWidth: "min(300px, 80vw)",
          maxHeight: "min(200px, 20vh)",
          marginBottom: "clamp(1rem, 5vh, 3rem)",
          objectFit: "contain"
        }}
      />

      <div style={{
        display: "flex",
        flexDirection: "column",
        gap: "clamp(0.5rem, 2vh, 1rem)",
        alignItems: "center",
        width: "100%",
        maxWidth: "400px"
      }}>
        <Link
          to="/photo_wall"
          style={{
            backgroundColor: "#4facfe",
            color: "white",
            padding: "clamp(0.75rem, 2vh, 1rem) clamp(1.5rem, 4vw, 2rem)",
            borderRadius: "8px",
            textDecoration: "none",
            fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
            fontWeight: 500,
            transition: "background-color 0.3s ease",
            minWidth: "clamp(240px, 60vw, 280px)",
            textAlign: "center",
            width: "100%"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#3d8bfe";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#4facfe";
          }}
        >
          📸 Painel de Fotos
        </Link>
        <Link
          to="/caixa_holo"
          style={{
            backgroundColor: "#764ba2",
            color: "white",
            padding: "clamp(0.75rem, 2vh, 1rem) clamp(1.5rem, 4vw, 2rem)",
            borderRadius: "8px",
            textDecoration: "none",
            fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
            fontWeight: 500,
            transition: "background-color 0.3s ease",
            minWidth: "clamp(240px, 60vw, 280px)",
            textAlign: "center",
            width: "100%"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#6b419a";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#764ba2";
          }}
        >
          🛸 Caixa Holográfica
        </Link>
        <Link
          to="/two_section_layout"
          style={{
            backgroundColor: "#20B2AA",
            color: "white",
            padding: "clamp(0.8rem, 2vw, 1rem) clamp(1.5rem, 4vw, 2rem)",
            borderRadius: "8px",
            textDecoration: "none",
            fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
            fontWeight: 500,
            transition: "background-color 0.3s ease",
            minWidth: "clamp(200px, 40vw, 280px)",
            textAlign: "center"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#1E9A92";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#20B2AA";
          }}
        >
          💬 Painel Palavras
        </Link>
        <Link
          to="/qr_cadastro"
          style={{
            backgroundColor: "#48bb78",
            color: "white",
            padding: "clamp(0.8rem, 2vw, 1rem) clamp(1.5rem, 4vw, 2rem)",
            borderRadius: "8px",
            textDecoration: "none",
            fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
            fontWeight: 500,
            transition: "background-color 0.3s ease",
            minWidth: "clamp(200px, 40vw, 280px)",
            textAlign: "center"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#38a169";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#48bb78";
          }}
        >
          📱 Atualiza Cadastro
        </Link>
        <Link
          to="/checkin_tunel"
          style={{
            backgroundColor: "#9f7aea",
            color: "white",
            padding: "clamp(0.8rem, 2vw, 1rem) clamp(1.5rem, 4vw, 2rem)",
            borderRadius: "8px",
            textDecoration: "none",
            fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
            fontWeight: 500,
            transition: "background-color 0.3s ease",
            minWidth: "clamp(200px, 40vw, 280px)",
            textAlign: "center"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#8b5aea";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#9f7aea";
          }}
        >
          🎯 Check-in Túnel
        </Link>
        <Link
          to="/checkin_caixa"
          style={{
            backgroundColor: "#ff6b35",
            color: "white",
            padding: "clamp(0.8rem, 2vw, 1rem) clamp(1.5rem, 4vw, 2rem)",
            borderRadius: "8px",
            textDecoration: "none",
            fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
            fontWeight: 500,
            transition: "background-color 0.3s ease",
            minWidth: "clamp(200px, 40vw, 280px)",
            textAlign: "center"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#e55a2b";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#ff6b35";
          }}
        >
          📦 Check-in Caixa
        </Link>
        <Link
          to="/qr_viewer"
          style={{
            backgroundColor: "#ed8936",
            color: "white",
            padding: "clamp(0.8rem, 2vw, 1rem) clamp(1.5rem, 4vw, 2rem)",
            borderRadius: "8px",
            textDecoration: "none",
            fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
            fontWeight: 500,
            transition: "background-color 0.3s ease",
            minWidth: "clamp(200px, 40vw, 280px)",
            textAlign: "center"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#dd7624";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#ed8936";
          }}
        >
          👀 Visualiza Cadastro
        </Link>
        <Link
          to="/teste_caixa"
          style={{
            backgroundColor: "#f093fb",
            color: "white",
            padding: "clamp(0.8rem, 2vw, 1rem) clamp(1.5rem, 4vw, 2rem)",
            borderRadius: "8px",
            textDecoration: "none",
            fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
            fontWeight: 500,
            transition: "background-color 0.3s ease",
            minWidth: "clamp(200px, 40vw, 280px)",
            textAlign: "center"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#e578f0";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#f093fb";
          }}
        >
          Teste Caixa
        </Link>
        <Link
          to="/painel_palavras_2"
          style={{
            backgroundColor: "#6b73ff",
            color: "white",
            padding: "clamp(0.8rem, 2vw, 1rem) clamp(1.5rem, 4vw, 2rem)",
            borderRadius: "8px",
            textDecoration: "none",
            fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
            fontWeight: 500,
            transition: "background-color 0.3s ease",
            minWidth: "clamp(200px, 40vw, 280px)",
            textAlign: "center"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#5b63ff";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#6b73ff";
          }}
        >
          💫 Painel de Palavras 2
        </Link>
      </div>
    </div>
  );
};

export default Main;
